import { useEnablePinLoginForLocation } from 'api/hooks/useLocationSetting';
import { resolveOverrideOffSetting } from 'utils/helpers/locationSetting.helpers';
import { isPinFeatureOn } from 'utils/helpers/pinFeatureFlag.helpers';
import useEnablePinLogin from './useEnablePinLogin';

// PIN login is on for the location, and not switched off for this browser
export const usePinLoginEnabled = (): boolean => {
  const { forLocation } = useEnablePinLoginForLocation();
  const [onThisBrowser] = useEnablePinLogin();
  return isPinFeatureOn() && resolveOverrideOffSetting(forLocation, onThisBrowser);
};
